export const colors = {
  white: '#FFFFFF',
  grey0: '#e9e9e9',
  grey1: '#C5C5CD',
  grey2: '#797982',
  black: '#222325',

  blue1: '#F7F8FC',
  blue2: '#EEEFFF',
  blue3: '#4A77EA',
};
